<template>
  <DModal :isBgOverlay="true"
          :show-close="false">
    <div class="do-modal" slot="insertComponent">
      <div class="do-modal__header">
        <h2>Grupper med pædagogoptælling</h2>
        <div class="icon__bg-circle ww-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="do-modal__body">
        <section class="modal-section">
          <h4>Grupper uden forberedelsesfaktor</h4>
          <p class="marg-1-bottom">
            For disse grupper sættes
            forberedelsesfaktoren
            til 0, så undervisningstimer ikke automatisk udløser forberedelsestid.
            <a href="https://docendohelp.crisp.help/da/article/optaelling-af-timer-pa-paedagoger-arsnorm-1ww8w39"
               target="_blank" rel="noopener noreferrer">Læs evt. mere i den uddybende vejledning</a>.
          </p>
          <DoFiltersFilter
            :title="'Grupper'"
            :tags="tags"
            :selectedTags="selectedTags"
            :numberOfSelectedTagsToShow="6"
            :placeholder="'Vælg grupper'"
            @select="toggleTag"
            @clear="clearTags">
          </DoFiltersFilter>
        </section>
        <section class="modal-section marg-2-top">
          <h4>Grupper hvor arbejdstid tælles som sum af alle skemalagte timer</h4>
          <p class="marg-1-bottom">
            For disse grupper tælles
            skemalagt arbejdstid
            som summen af alle skemalagte timer (fx SFO-tid, UV-tid, vikartimer osv.) i stedet for backendens beregnede arbejdstid.
          </p>
          <DoFiltersFilter
            :title="'Grupper'"
            :tags="tags"
            :selectedTags="selectedTagsSumWorkHours"
            :numberOfSelectedTagsToShow="6"
            :placeholder="'Vælg grupper'"
            @select="toggleTagSumWorkHours"
            @clear="clearTagsSumWorkHours">
          </DoFiltersFilter>
        </section>
      </div>
      <div class="do-modal__footer">
        <button class="do-bttn marg-1-right" @click="$emit('close')">Annuller</button>
        <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSaving}"
                @click="save">{{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
  </DModal>

</template>
<script>
import DModal from '../common/DModal.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'

export default {
  components: {DoFiltersFilter, DModal},
  props: {
    schoolId: {},
    tags: {
      type: Array,
      default: () => []
    },
    preSelectedTags: {
      type: Array,
      default: () => []
    },
    preSelectedTagsSumWorkHours: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isSaving: false,
      selectedTags: [],
      selectedTagsSumWorkHours: []
    }
  },
  methods: {
    save () {
      const noPrepKey = 'pedagogicalGroups'
      const sumWorkHoursKey = 'workHoursSumGroups'
      this.isSaving = true

      const noPrepValue = Array.isArray(this.selectedTags) && this.selectedTags.length > 0
        ? this.selectedTags.slice()
        : null
      const sumWorkHoursValue = Array.isArray(this.selectedTagsSumWorkHours) && this.selectedTagsSumWorkHours.length > 0
        ? this.selectedTagsSumWorkHours.slice()
        : null

      this.$store.dispatch('updateSchoolSettings', {
        [noPrepKey]: noPrepValue,
        [sumWorkHoursKey]: sumWorkHoursValue
      })

      setTimeout(_ => {
        this.$store.dispatch('trackEvent', 'assignHours_pedagogicalGroups_saved')
        this.$emit('saved')
        this.$emit('close')
      }, 500)
    },
    toggleTag (tag) {
      const idx = this.selectedTags.indexOf(tag)
      if (idx > -1) {
        this.selectedTags.splice(idx, 1)
      } else {
        this.selectedTags.push(tag)
      }
    },
    clearTags () {
      this.selectedTags = []
    },
    toggleTagSumWorkHours (tag) {
      const idx = this.selectedTagsSumWorkHours.indexOf(tag)
      if (idx > -1) {
        this.selectedTagsSumWorkHours.splice(idx, 1)
      } else {
        this.selectedTagsSumWorkHours.push(tag)
      }
    },
    clearTagsSumWorkHours () {
      this.selectedTagsSumWorkHours = []
    }
  },
  mounted () {
    this.selectedTags = Array.isArray(this.preSelectedTags)
      ? this.preSelectedTags.slice()
      : []
    this.selectedTagsSumWorkHours = Array.isArray(this.preSelectedTagsSumWorkHours)
      ? this.preSelectedTagsSumWorkHours.slice()
      : []
  }
}
</script>


<style scoped>
.do-modal__body {
  min-width: 400px;
  padding: 1rem;
  max-width: 600px;
}

.modal-section {
  display: block;
}

:root {
  --mark-bg: #fefce8;
}

@media (prefers-color-scheme: dark) {
  :root {
    /* lidt dæmpet gul på mørk baggrund */
    --mark-bg: rgba(250, 204, 21, 0.28) /* ca. amber med alpha */
  }
}

mark {
  background: var(--mark-bg);
  color: #a26206;
  padding: 0 .15em;
  border-radius: .2em;
  /* modvirker “klip” omkring tekst */
  box-shadow: 0 0 0 .1em var(--mark-bg);
}

</style>



// WEBPACK FOOTER //
// ModalPedagogicalSetting.vue?2b2abf8e